(function() {
  'use strict';

  function parseDisabledIds(attr) {
    if (!attr) return [];
    return attr.split(',').map(function(id) { return parseInt(id, 10); });
  }

  function patchAndRefresh(el) {
    if (!el.product) return false;
    var ids = parseDisabledIds(el.getAttribute('data-disabled-variants'));
    if (!ids.length) return true;

    el.product.variants.forEach(function(v) {
      if (ids.indexOf(v.id) !== -1) v.available = false;
    });

    if (typeof el._updateDisableSelectors === 'function') {
      el._updateDisableSelectors();
    }

    var formId = el.getAttribute('form-id');
    var form = document.getElementById(formId);
    if (form && el.selectedVariant) {
      form.dispatchEvent(new CustomEvent('variant:changed', {
        detail: { variant: el.selectedVariant },
        bubbles: true
      }));
    }
    return true;
  }

  function waitAndPatch(el) {
    var attempts = 0;
    var timer = setInterval(function() {
      if (patchAndRefresh(el) || ++attempts > 100) clearInterval(timer);
    }, 50);
  }

  function processElement(el) {
    if (!el.getAttribute('data-disabled-variants')) return;
    if (el.dataset.disabledPatched) return;
    el.dataset.disabledPatched = 'true';
    waitAndPatch(el);
  }

  function processAll() {
    document.querySelectorAll('product-variants[data-disabled-variants]').forEach(processElement);
  }

  function init() {
    processAll();

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'PRODUCT-VARIANTS') {
            processElement(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('product-variants[data-disabled-variants]').forEach(processElement);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
